export const theme = {
    colors: {
      bgPrimary: '#6A786F', 
      bgSecondary: '#DADED7', 
      bgThird: '#f4f4f4',
      textPrimary: '#fff',
      textSecondary: '#252c1f',
    },
  };
  